import { useTranslation } from "react-i18next";
import BackLink from "../../components/Common/BackLink";

const Error = () => {
    const { t } = useTranslation();

    return (
        <div className="mx-auto flex h-screen max-w-screen-xl items-center justify-center px-6">
            <div className="w-full max-w-screen-sm rounded-3xl border border-slate-200 bg-white p-10 text-center shadow-[0_20px_60px_rgba(15,27,143,0.08)]">
                <h1 className="mb-4 text-7xl font-extrabold tracking-tight text-primary lg:text-9xl">404</h1>
                <p className="mb-3 text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">{t("ERROR_404_TITLE")}</p>
                <p className="mb-6 text-base font-medium text-slate-500">{t("ERROR_404_SUBTITLE")}</p>
                <BackLink
                    label={t("ERROR_404_BACK_TO_DASHBOARD")}
                    to="/dashboard"
                    className="inline-flex items-center gap-2 text-sm font-semibold text-primary underline underline-offset-4"
                />
            </div>
        </div>
    );
};

export default Error;
